
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fZTy7", function(module, exports) {

$parcel$export(module.exports, "CreateCommitDropdown", () => $df3bc9cb5ccd6a29$export$6abc9e0bd1890013);
$parcel$export(module.exports, "default", () => $df3bc9cb5ccd6a29$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $fJs28 = parcelRequire("fJs28");
const $df3bc9cb5ccd6a29$var$entryPointParams = {};
const $df3bc9cb5ccd6a29$export$6abc9e0bd1890013 = ({ onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const previousOpen = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fJs28.createCommitDropdownContentEntrypoint), $df3bc9cb5ccd6a29$var$entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    (0, $5uXOq.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'commitCreateDropdown');
            !isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'commitCreateDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        isOpen,
        onOpenDropdown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        id: "create-commit-dropdown",
        testId: "development-summary-commit.ui.create-commit-dropdown.popup",
        zIndex: (0, $gwIPs.layers).modal + 1,
        placement: "bottom-end",
        messageId: "development-summary-commit.ui.create-commit-dropdown.popup",
        messageType: "transactional",
        shouldFlip: true,
        trigger: (triggerProps)=>getDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "dev-panel-create-commit-dropdown-content",
                packageName: "jira-development-summary-commit",
                fallback: null,
                runtimeProps: {}
            })
    });
};
var $df3bc9cb5ccd6a29$export$2e2bcd8739ae039 = $df3bc9cb5ccd6a29$export$6abc9e0bd1890013;

});
parcelRegister("fJs28", function(module, exports) {

$parcel$export(module.exports, "createCommitDropdownContentEntrypoint", () => $c8668e80dc73632f$export$e7b0c71bc90db4e9);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $c8668e80dc73632f$export$e7b0c71bc90db4e9 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("l1jrw")), {
        moduleId: "c85aa6fe"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("l1jrw", function(module, exports) {

let $f4d8c5e96019c278$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4d8c5e96019c278$var$load("aQAmT").then(()=>parcelRequire('eCscP'));

});




$parcel$global.rlb("cNRxo")
//# sourceMappingURL=index-new.0425a576.js.map
